module.exports = __webpack_public_path__ + "static/img/enterpriseCertificationSuccess.d88a412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterpriseCertificationSuccess.png
// module id = ow8f
// module chunks = 0